import React, { useState } from "react";
import { cn } from "lib/utils";
import { Card, CardContent } from "components/ui/card";

function DetailsTable({ logData, keyList, theme, itemsPerPage = 500, rowHighlightClass }) {
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(logData.length / itemsPerPage);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = logData.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <Card className="mt-3 w-full">
            <CardContent className="p-4">
                {logData.length > itemsPerPage && (
                    <nav className="mb-2 flex flex-wrap justify-end gap-1">
                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i}
                                onClick={() => paginate(i + 1)}
                                className={cn(
                                    "min-w-[2rem] rounded-md border border-border px-2 py-1 text-xs transition-colors",
                                    currentPage === i + 1
                                        ? "bg-primary text-primary-foreground"
                                        : "hover:bg-accent hover:text-accent-foreground"
                                )}
                            >
                                {i + 1}
                            </button>
                        ))}
                    </nav>
                )}
                <div className="overflow-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b border-border text-left text-muted-foreground">
                                {keyList.map((item, index) => (
                                    <th scope="col" key={index} className="px-3 py-2 font-medium">
                                        {item}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="text-xs">
                            {currentItems.map((row, rowIndex) => {
                                const highlightClass = rowHighlightClass ? rowHighlightClass(row) : "";
                                return (
                                    <tr
                                        key={rowIndex}
                                        className={cn(
                                            "border-b border-border/60",
                                            highlightClass || "odd:bg-muted/30"
                                        )}
                                    >
                                        {keyList.map((colKey, colIndex) => (
                                            <td key={colIndex} className="px-3 py-1.5">{row[colKey]}</td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </CardContent>
        </Card>
    );
}

export default DetailsTable;
